import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { StudyCard } from "@/features/catalog/StudyCard";
import { useStudies } from "@/features/catalog/useStudies";

export const Route = createFileRoute("/_auth/")({ component: HomePage });

function greeting(hour: number): string {
  if (hour < 12) return "Buenos días";
  if (hour < 19) return "Buenas tardes";
  return "Buenas noches";
}

function HomePage() {
  const { t } = useTranslation();
  const { user } = Route.useRouteContext();
  const recent = useStudies({ pageSize: 4, sort: "recent" });

  const firstName = user.name.split(" ")[0] ?? user.name;

  return (
    <div className="px-8 py-10">
      <p className="text-nota text-ink3">{greeting(new Date().getHours())},</p>
      <h1 className="mt-0.5">{firstName}</h1>

      <section className="mt-8">
        <div className="mb-3 flex items-baseline justify-between">
          <h2 className="text-ink2">{t("catalog.recent")}</h2>
          <Link to="/insights" className="text-micro text-bur hover:underline">
            {t("catalog.all")}
          </Link>
        </div>

        {recent.isPending && <p className="text-nota text-ink3">{t("common.loading")}</p>}

        {recent.data && recent.data.items.length === 0 && (
          <p className="text-nota text-ink3">{t("catalog.empty")}</p>
        )}

        {recent.data && recent.data.items.length > 0 && (
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {recent.data.items.map((study) => (
              <li key={study.id}>
                <StudyCard study={study} />
              </li>
            ))}
          </ul>
        )}
      </section>
    </div>
  );
}
